function animateSteps(el) {
    const steps = [...el.querySelectorAll('.step')]
    const stepsCount = steps.length
    let intervalId = null

    const getContent = step => step.querySelector('.step__content')

    const expandContent = content => {
        if (!content) return

        content.style.height = '0px'
        content.offsetHeight
        content.style.height = `${content.scrollHeight}px`

        content.addEventListener(
            'transitionend',
            event => {
                if (event.propertyName === 'height') {
                    content.style.height = 'auto'
                }
            },
            { once: true }
        )
    }

    const collapseContent = content => {
        if (!content) return

        content.style.height = `${content.scrollHeight}px`
        content.offsetHeight
        content.style.height = '0px'
    }

    const setActiveStep = nextStep => {
        steps.forEach(step => {
            const content = getContent(step)
            const isActive = step === nextStep

            if (step.classList.contains('active') && !isActive) {
                collapseContent(content)
            }

            step.classList.toggle('active', isActive)
        })

        expandContent(getContent(nextStep))
    }

    const startInterval = () => {
        if (intervalId) {
            clearInterval(intervalId)
        }

        intervalId = setInterval(() => {
            const activeIndex = steps.findIndex(step => step.classList.contains('active'))
            const currentIndex = activeIndex === -1 ? 0 : activeIndex
            const nextIndex = (currentIndex + 1) % stepsCount

            setActiveStep(steps[nextIndex])
        }, 7500)
    }

    steps.forEach(step => {
        const content = getContent(step)
        if (content) {
            content.style.height = step.classList.contains('active') ? 'auto' : '0px'
        }

        step.addEventListener('click', () => {
            setActiveStep(step)
            startInterval()
        })
    })

    if (stepsCount > 1) {
        startInterval()
    }
}


export default function init() {
	[...document.querySelectorAll('.steps')].map(animateSteps)
}



